module.exports = __webpack_public_path__ + "static/img/logo.70a1ada1.svg";